import React from 'react';
import { Box } from '@mui/material';

const VerticalDivider = () => {
  return (
    <Box
      sx={{
        marginY: 2,
        width: '2px',
        height: '95%',
        backgroundColor: 'black',
      }}
    />
  );
};

export default VerticalDivider;